import { Component, model, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {CommonService} from "../../../core/services/common.service";
import {HttpClientService} from "../../../core/services/http-client.service";
import {ToastService} from "../../../core/services/toast.service";
import {CartService} from "../../../core/services/cart.service";

@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.css']
})
export class ProductDetailsComponent {

  relatedProducts: any = [];
  offers: any[] = [];
  product: any = null;
  selectedItemIndex: number = 0;
  selectedVariantIndex: number = 0;
  entity: any = {};
  loader: boolean = true;
  extendedWarranties: any[] = [];
  productFound:boolean=false;
  responsiveOptions: any[] | undefined;
  issuerIndex = 0;
  constructor(private router: Router, private route: ActivatedRoute, private common: CommonService, private http: HttpClientService, private toast: ToastService, private cartService: CartService) {
    this.getProductDetail(this.route.snapshot.paramMap.get('id'));
  }

  ngOnInit(): void {

    this.responsiveOptions = [
      {
        breakpoint: '1400px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '1199px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '767px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '575px',
        numVisible: 1,
        numScroll: 1,
      },
    ];

  }

  private getProductDetail(productID) {
    this.http.get(`entity/${productID}`).subscribe((res)=>{
      if (res.statusCode == 200){
        this.entity = res.response.entity;
        this.http.get(`store/entity/${productID}`).subscribe(async (product)=>{
          if (product.statusCode == 200){
            this.product = product.response;
            this.getEmiOptions(this.product);
            this.getSimilarModels(productID);
            this.product.items = product.response.items.filter(item => item.color.toLowerCase() != "any colour");
            if(product.response.superCatalogVariants) this.product.superCatalogVariants = JSON.parse(product.response.superCatalogVariants);
            this.offers = this.product.webOffers;
            if (this.product.isSmartPhone) await this.getExtendedWarranty(product.response.items[this.selectedItemIndex].item_id, product.response.items[this.selectedItemIndex].mop);
          }
        });
      }
      this.loader = false;
      this.productFound=true;
    }, (error)=>{
      this.loader = false;
    });
  }

  chunkArray(array: any[], size: number): any[] {
    const chunked = [];
    for (let i = 0; i < array.length; i += size) {
      chunked.push(array.slice(i, i + size));
    }
    return chunked;
  }

  isModalVisible: boolean = false;
  modalImage: string = '';
  offersSidebar: boolean = false;
  selectedRowIndex = null;

  calculateDiscount(item: any) {
    if (item.mrp && item.mop) {
      const discount = Math.round(((item.mrp - item.mop) / item.mrp) * 100);
      return {
        percent: `${discount}% off`,
        amount: (item.mrp - item.mop).toFixed(2)
      };
    }
    return { percent: '0% off', amount: "0.00" };
  }

  addToCart() {
    let item = this.product.items[this.selectedItemIndex];
    item['itemId'] = item.item_id;
    this.cartService.addToCart(item);
  }

  buyNow() {
    //this.cartService.clearCart();
    this.addToCart()
    this.router.navigateByUrl(`/cart`);
  }

  selectColor(selectedItem: any) {
    this.selectedItemIndex = this.product.items.findIndex(item => item.color == selectedItem.color);
  }

  getSimilarModels(modelId: any) {
    this.http.get(`/fofo/similar-models/${modelId}`).subscribe(models => {
      this.product.similarModels = models.response;
    })
  }

  getEmiOptions(product) {
    const params = {
      provider: "pinelabs",
      amountInPaisa: (product.items[this.selectedItemIndex].mop - product.items[this.selectedItemIndex].cashback)*100,
      productDetails: JSON.stringify([{product_code:product.items[this.selectedItemIndex].item_id,product_amount:(product.items[this.selectedItemIndex].mop - product.items[this.selectedItemIndex].cashback)*100}])
    }
    this.http.post(`/payments/get-emi-options`,params).subscribe(emi => {
      if (emi.statusCode == 200) this.product.emiOptions = emi.response.issuers;
    })
  }

  async getExtendedWarranty(itemId, amount) {
    this.extendedWarranties = (await this.http.get(`/store/checkplans?itemId=${itemId}&price=${amount}`).toPromise()).response;
  }

  selectWarranty(wIndex: number) {
    const warranty = this.extendedWarranties[wIndex];
    this.product.items[this.selectedItemIndex]['pendingOrderItemPolicyPlan'] = {
      id: warranty.productId,
      name: warranty.planName,
      price: warranty.premium,
      duration: warranty.duration
    }
  }

  selectVariant(index:number) {
    this.selectedVariantIndex = index;
    this.getProductDetail(this.product.superCatalogVariants[index].catalogId);
  }

  get numVisible(): number {
    if (!this.product?.similarModels) return 5;
    return Math.min(5, this.product.similarModels.length);
  }

  getLowestEMI(emiData: any[]) {
    let lowestEMI = Infinity;

    emiData.forEach((issuer) => {
      issuer.listEmiTenure.forEach((tenure) => {
        if (tenure.monthlyInstallment > 0 && tenure.monthlyInstallment < lowestEMI) {
          lowestEMI = tenure.monthlyInstallment;
        }
      });
    });

    return lowestEMI !== Infinity ? lowestEMI : 0;
  }
}
